(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bn.js"));
	else if(typeof define === 'function' && define.amd)
		define("Macaron-Cli", ["bn.js"], factory);
	else if(typeof exports === 'object')
		exports["Macaron-Cli"] = factory(require("bn.js"));
	else
		root["Macaron-Cli"] = factory(root["bn.js"]);
})(global, function(__WEBPACK_EXTERNAL_MODULE__6__) {
return 